import { render, staticRenderFns } from "./Ressource.vue?vue&type=template&id=14d12e96"
import script from "./Ressource.vue?vue&type=script&lang=js"
export * from "./Ressource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports